










import { ScoutingPlace } from "@/models";
import { Vue, Component, Ref } from "vue-property-decorator";
import { Position } from "@/models/Position";
import { currentScoutingStore } from "@/store/typed";
import VGoogleMap from "@/components/VGoogleMap.vue";
import {
  AREA_FILL_COLOR,
  AREA_FILL_COLOR_SELECTED,
  AREA_STROKE_COLOR,
  AREA_STROKE_COLOR_SELECTED,
  PIN_ICON_FILL_COLOR,
  PIN_ICON_FILL_COLOR_SELECTED,
  PIN_ICON_STROKE_COLOR,
  PIN_ICON_STROKE_COLOR_SELECTED,
  PIN_ICON_SVG,
  PIN_ICON_ZOOMED_FILL_COLOR,
  PIN_ICON_ZOOMED_STROKE_COLOR,
  POLYGON_FILL_COLOR,
  POLYGON_STROKE_COLOR,
} from "@/utils/Map";
import ScoutingArea from "@/models/ScoutingArea";
import { Area, Marker } from "@/models/MapObjects";

@Component({
  components: {
    VGoogleMap,
  },
})
export default class MapObj extends Vue {
  @Ref() readonly map!: VGoogleMap;
  private mapObjects = new Map();

  getPinIcon(selected: boolean) {
    return {
      path: PIN_ICON_SVG,
      strokeColor: selected
        ? PIN_ICON_STROKE_COLOR_SELECTED
        : PIN_ICON_STROKE_COLOR,
      strokeOpacity: 1,
      strokeWeight: 2,
      fillColor: selected ? PIN_ICON_FILL_COLOR_SELECTED : PIN_ICON_FILL_COLOR,
      fillOpacity: 1,
      rotation: 0,
      scale: 0.8,
      anchor: new window.google.maps.Point(30, 30),
    };
  }

  buildMarkerOptions() {
    return {
      icon: this.getPinIcon(true),
    };
  }

  buildAreaOptions(selected = false) {
    return {
      strokeColor: selected ? AREA_STROKE_COLOR_SELECTED : AREA_STROKE_COLOR,
      strokeOpacity: 0.8,
      strokeWeight: 2,
      fillColor: selected ? AREA_FILL_COLOR_SELECTED : AREA_FILL_COLOR,
      fillOpacity: 0.5,
    };
  }

  addMarker(marker: Marker) {
    this.map.addMarker(marker.id, marker.position, this.buildMarkerOptions());
    this.mapObjects.set(marker.id, marker);
  }

  addArea(area: Area) {
    this.map.drawPolygon(area.id, area.paths, this.buildAreaOptions(true));
    this.mapObjects.set(area.id, area);
  }

  centerAllObjects() {
    const path: Position[] = [];
    this.mapObjects.forEach((value: Marker | Area, key: string) => {
      if (value instanceof Marker) {
        path.push(value.position);
      }
      if (value instanceof Area) {
        for (const pathPolygon of value.paths) {
          path.push(...pathPolygon);
        }
      }
    });
    this.map.centerOnBounds(path);
  }

  removeAllObjects() {
    this.mapObjects.forEach((value: Marker | Area, key: string) => {
      if (value instanceof Marker) {
        this.map.removeMarker(value.id);
      }
      if (value instanceof Area) {
        this.map.removePolygon(value.id);
      }
    });
    this.mapObjects = new Map();
  }

  removeMarker(id: string) {
    this.map.removeMarker(id);
  }

  removeArea(id: string) {
    this.map.removePolygon(id);
  }

  onMarkerClick(markerId: string) {}

  onPolygonClick(polygonId: string) {}
}
